module.exports = __webpack_public_path__ + "img/arrow.7f878503.svg";